/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AgentSystemKnowledge__AgentSystemLessonFragment = { __typename: 'AgentSystemLesson', id: string, kind: Types.AgentSystemLessonKind, lesson: string, tools: Array<string>, status: Types.AgentSystemLessonStatus, source: Types.AgentSystemLessonSource, occurrences: number, organisationCount: number, occurrencesSinceApproval: number, proposedAt: any, decidedAt?: any | null, decidedBy?: string | null, decidedByName?: string | null, evidence: Array<{ __typename: 'AgentSystemLessonEvidence', at: any, tools: Array<string>, error?: string | null, recovered: boolean, note: string }>, decisions: Array<{ __typename: 'AgentSystemLessonDecision', at: any, from: Types.AgentSystemLessonStatus, to: Types.AgentSystemLessonStatus, byUserId?: string | null, byName: string, reason: string }> };

export type AgentSystemLessonsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AgentSystemLessonsQuery = { agentSystemLessons: { __typename: 'AgentSystemLessonsResult', lessons: Array<{ __typename: 'AgentSystemLesson', id: string, kind: Types.AgentSystemLessonKind, lesson: string, tools: Array<string>, status: Types.AgentSystemLessonStatus, source: Types.AgentSystemLessonSource, occurrences: number, organisationCount: number, occurrencesSinceApproval: number, proposedAt: any, decidedAt?: any | null, decidedBy?: string | null, decidedByName?: string | null, evidence: Array<{ __typename: 'AgentSystemLessonEvidence', at: any, tools: Array<string>, error?: string | null, recovered: boolean, note: string }>, decisions: Array<{ __typename: 'AgentSystemLessonDecision', at: any, from: Types.AgentSystemLessonStatus, to: Types.AgentSystemLessonStatus, byUserId?: string | null, byName: string, reason: string }> }>, lastRun?: { __typename: 'AgentSystemLessonRun', id: string, trigger: Types.AgentSystemLessonRunTrigger, startedAt: any, finishedAt?: any | null, report?: { __typename: 'AgentSystemLessonRunReport', scannedMessages: number, signals: number, proposed: number, updated: number, errors: Array<string> } | null } | null } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type MineAgentSystemLessonsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type MineAgentSystemLessonsMutation = { mineAgentSystemLessons: { __typename: 'MineAgentSystemLessonsResult', runId: string } };

export type UpdateAgentSystemLessonMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  lesson?: Types.InputMaybe<Types.Scalars['String']['input']>;
  status?: Types.InputMaybe<Types.AgentSystemLessonDecisionStatus>;
  reason?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateAgentSystemLessonMutation = { updateAgentSystemLesson: { __typename: 'UpdateAgentSystemLessonResult', lesson: { __typename: 'AgentSystemLesson', id: string, kind: Types.AgentSystemLessonKind, lesson: string, tools: Array<string>, status: Types.AgentSystemLessonStatus, source: Types.AgentSystemLessonSource, occurrences: number, organisationCount: number, occurrencesSinceApproval: number, proposedAt: any, decidedAt?: any | null, decidedBy?: string | null, decidedByName?: string | null, evidence: Array<{ __typename: 'AgentSystemLessonEvidence', at: any, tools: Array<string>, error?: string | null, recovered: boolean, note: string }>, decisions: Array<{ __typename: 'AgentSystemLessonDecision', at: any, from: Types.AgentSystemLessonStatus, to: Types.AgentSystemLessonStatus, byUserId?: string | null, byName: string, reason: string }> } } };

export const AgentSystemKnowledge__AgentSystemLessonFragmentDoc = gql`
    fragment AgentSystemKnowledge__AgentSystemLesson on AgentSystemLesson {
  id
  kind
  lesson
  tools
  status
  source
  evidence {
    at
    tools
    error
    recovered
    note
  }
  occurrences
  organisationCount
  occurrencesSinceApproval
  proposedAt
  decidedAt
  decidedBy
  decisions {
    at
    from
    to
    byUserId
    byName
    reason
  }
  decidedByName
}
    `;
export const AgentSystemLessonsDocument = gql`
    query AgentSystemLessons {
  agentSystemLessons {
    __typename
    ... on AgentSystemLessonsResult {
      lessons {
        ...AgentSystemKnowledge__AgentSystemLesson
      }
      lastRun {
        id
        trigger
        startedAt
        finishedAt
        report {
          scannedMessages
          signals
          proposed
          updated
          errors
        }
      }
    }
  }
}
    ${AgentSystemKnowledge__AgentSystemLessonFragmentDoc}`;

/**
 * __useAgentSystemLessonsQuery__
 *
 * To run a query within a React component, call `useAgentSystemLessonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentSystemLessonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentSystemLessonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAgentSystemLessonsQuery(baseOptions?: Apollo.QueryHookOptions<AgentSystemLessonsQuery, AgentSystemLessonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgentSystemLessonsQuery, AgentSystemLessonsQueryVariables>(AgentSystemLessonsDocument, options);
      }
export function useAgentSystemLessonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgentSystemLessonsQuery, AgentSystemLessonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgentSystemLessonsQuery, AgentSystemLessonsQueryVariables>(AgentSystemLessonsDocument, options);
        }
export function useAgentSystemLessonsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AgentSystemLessonsQuery, AgentSystemLessonsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AgentSystemLessonsQuery, AgentSystemLessonsQueryVariables>(AgentSystemLessonsDocument, options);
        }
export type AgentSystemLessonsQueryHookResult = ReturnType<typeof useAgentSystemLessonsQuery>;
export type AgentSystemLessonsLazyQueryHookResult = ReturnType<typeof useAgentSystemLessonsLazyQuery>;
export type AgentSystemLessonsSuspenseQueryHookResult = ReturnType<typeof useAgentSystemLessonsSuspenseQuery>;
export type AgentSystemLessonsQueryResult = Apollo.QueryResult<AgentSystemLessonsQuery, AgentSystemLessonsQueryVariables>;
export const MineAgentSystemLessonsDocument = gql`
    mutation MineAgentSystemLessons {
  mineAgentSystemLessons {
    runId
  }
}
    `;
export type MineAgentSystemLessonsMutationFn = Apollo.MutationFunction<MineAgentSystemLessonsMutation, MineAgentSystemLessonsMutationVariables>;

/**
 * __useMineAgentSystemLessonsMutation__
 *
 * To run a mutation, you first call `useMineAgentSystemLessonsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMineAgentSystemLessonsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mineAgentSystemLessonsMutation, { data, loading, error }] = useMineAgentSystemLessonsMutation({
 *   variables: {
 *   },
 * });
 */
export function useMineAgentSystemLessonsMutation(baseOptions?: Apollo.MutationHookOptions<MineAgentSystemLessonsMutation, MineAgentSystemLessonsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MineAgentSystemLessonsMutation, MineAgentSystemLessonsMutationVariables>(MineAgentSystemLessonsDocument, options);
      }
export type MineAgentSystemLessonsMutationHookResult = ReturnType<typeof useMineAgentSystemLessonsMutation>;
export type MineAgentSystemLessonsMutationResult = Apollo.MutationResult<MineAgentSystemLessonsMutation>;
export type MineAgentSystemLessonsMutationOptions = Apollo.BaseMutationOptions<MineAgentSystemLessonsMutation, MineAgentSystemLessonsMutationVariables>;
export const UpdateAgentSystemLessonDocument = gql`
    mutation UpdateAgentSystemLesson($id: ID!, $lesson: String, $status: AgentSystemLessonDecisionStatus, $reason: String) {
  updateAgentSystemLesson(
    id: $id
    lesson: $lesson
    status: $status
    reason: $reason
  ) {
    lesson {
      ...AgentSystemKnowledge__AgentSystemLesson
    }
  }
}
    ${AgentSystemKnowledge__AgentSystemLessonFragmentDoc}`;
export type UpdateAgentSystemLessonMutationFn = Apollo.MutationFunction<UpdateAgentSystemLessonMutation, UpdateAgentSystemLessonMutationVariables>;

/**
 * __useUpdateAgentSystemLessonMutation__
 *
 * To run a mutation, you first call `useUpdateAgentSystemLessonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgentSystemLessonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgentSystemLessonMutation, { data, loading, error }] = useUpdateAgentSystemLessonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      lesson: // value for 'lesson'
 *      status: // value for 'status'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useUpdateAgentSystemLessonMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgentSystemLessonMutation, UpdateAgentSystemLessonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgentSystemLessonMutation, UpdateAgentSystemLessonMutationVariables>(UpdateAgentSystemLessonDocument, options);
      }
export type UpdateAgentSystemLessonMutationHookResult = ReturnType<typeof useUpdateAgentSystemLessonMutation>;
export type UpdateAgentSystemLessonMutationResult = Apollo.MutationResult<UpdateAgentSystemLessonMutation>;
export type UpdateAgentSystemLessonMutationOptions = Apollo.BaseMutationOptions<UpdateAgentSystemLessonMutation, UpdateAgentSystemLessonMutationVariables>;